import {AUTH_ACTION} from '../action-types';
import {OrganizationModel, UserModel} from "../../utils/types";

export interface IAuthState {
  token: string;
  organizations: OrganizationModel[];
  activeOrganization: OrganizationModel;
  currentUser: UserModel | null;
  // Incremented every time the active organization actually changes. Used as a
  // React `key` so the whole routed tree remounts and re-fetches under the new
  // org instead of showing the previous org's data.
  orgVersion: number;
  orgSwitching: boolean;
}

const initialState: IAuthState = {
  token: null,
  organizations: [],
  activeOrganization: null,
  currentUser: null,
  orgVersion: 0,
  orgSwitching: false,
};

const authReducer = (state: IAuthState = initialState, action: any) => {
  switch (action.type) {
    case AUTH_ACTION.SET_TOKEN: {
      return {
        ...state,
        token: action.token,
      };
    }

    case AUTH_ACTION.SET_ORGANIZATIONS: {
      return {
        ...state,
        organizations: action.organizations,
        activeOrganization: state.activeOrganization,
      };
    }

    case AUTH_ACTION.SET_ACTIVE_ORGANIZATION: {
      return {
        ...state,
        activeOrganization: action.organization,
      };
    }

    case AUTH_ACTION.SET_CURRENT_USER: {
      return {
        ...state,
        currentUser: action.user,
      };
    }

    case AUTH_ACTION.SET_ORG_SWITCHING: {
      return {
        ...state,
        orgSwitching: action.switching,
      };
    }

    case AUTH_ACTION.ORG_CONTEXT_CHANGED: {
      return {
        ...state,
        orgVersion: state.orgVersion + 1,
      };
    }

    default:
      return state;
  }
};

export default authReducer;
